<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p6"><span class="sz"></span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p7"><span class="sz"><i>Our country has wide borders; there is no man</i></span></p>
<p class="p7"><span class="sz"><i>born has travelled round it. And it bears</i></span></p>
<p class="p7"><span class="sz"><i>secrets in its bosom of which no man dreams.</i></span></p>
<p class="p8"><span class="sz"> </span></p>
<p class="p7"><span class="sz"><i>Up here we live two different lives: in the summer,</i></span></p>
<p class="p7"><span class="sz"><i>under the torch of the warm sun, and in the</i></span></p>
<p class="p7"><span class="sz"><i>winter, under the lash of the north wind.</i></span></p>
<p class="p8"><span class="sz"><i></i> </span></p>
<p class="p7"><span class="sz"><i>And when the long Darkness spreads itself over the</i></span></p>
<p class="p7"><span class="sz"><i>country... men’s thoughts move along devious</i></span></p>
<p class="p7"><span class="sz"><i>paths... and many hidden things are revealed.</i></span></p>
<p class="p9"><span class="sz"> </span></p>
<p class="p4"><span class="sz">— Blind Ambrosius</span></p>
<p class="p9"><span class="sz"> </span></p>
<p class="p6"><span class="sz"></span></p>
<p class="p5"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?6e1b232e